import {Injectable} from '@angular/core';
import {IFile, IFileReq, IImageSlice} from "../models/file.model";
import {BaseService} from "../../../../../../base/services/base.service";
import {AuthService} from "../../../auth/services/auth.service";
import {NotifierService} from "../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {IParams} from "../../../../../../base/endpoints/iparams";
import {IPage} from "../../../../../../base/models/pagination.model";
import {IImageUploadResponse} from "../models/IImageUploadResponse";
import {CmsEndpoint} from "../../cms.endpoint";
import {IAuth} from "../../../../../common/modules/auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class FileService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBusService: EventBusService
  ) {
    super(authService, notifier)
  }

  search(key: string, endpoint: string, params: IParams) {
    let url = CmsEndpoint.FILES.SEARCH(endpoint, params)
    this.http.get<IPage<IFile>>(url)
      .subscribe((file: IPage<IFile>) => {
        this.eventBusService.publish(key, file)
      }, error => {
        this.handleError(error, (auth: IAuth) => {
          this.search(key, endpoint, params)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  fetchSingle(key: string, id: number) {
    this.http.get<IFile>(CmsEndpoint.FILES.GET(id))
      .subscribe((file: IFile) => {
        this.eventBusService.publish(key, file)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.fetchSingle(key, id)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(key), err)
        })
      })
  }

  upsert(key: string, fileReq: IFileReq, exId: number | null) {
    let endpoint = exId == null ? CmsEndpoint.FILES.CREATE() : CmsEndpoint.FILES.UPDATE(exId)
    let observable = exId == null ? this.http.post<number>(endpoint, fileReq)
      : this.http.patch(endpoint, fileReq)
    observable.subscribe(res => {
      this.eventBusService.publish(key, res)
    }, (err: HttpErrorResponse) => {
      this.handleError(err, (auth: IAuth) => {
        this.upsert(key, fileReq, exId)
      }, (err: HttpErrorResponse) => {
        this.eventBusService.publish(this.getErrorKey(key), err)
      })
    })
  }


  /*
  Image upload
   */


  upload(files: FileList) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    let url = CmsEndpoint.FILES.UPLOAD({
      'namespace': 'files'
    });
    return this.http.post(url, formData);
  }

  uploadImages(eventKey: string, files: File[]) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    let url = CmsEndpoint.FILES.UPLOAD({
      'namespace': 'files'
    });
    this.http.post<IImageUploadResponse[]>(url, formData)
      .subscribe((response: IImageUploadResponse[]) => {
        this.eventBusService.publish(eventKey, response);
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.uploadImages(eventKey, files)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(eventKey), err)
        })
      });
  }

  uploadImagesV2(eventKey: string, files: File[]) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    let url = CmsEndpoint.FILES.UPLOAD({
      'namespace': 'files'
    });
    this.http.post<IImageSlice[]>(url, formData)
      .subscribe((response: IImageSlice[]) => {
        this.eventBusService.publish(eventKey, response);
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.uploadImagesV2(eventKey, files)
        }, (err: HttpErrorResponse) => {
          this.eventBusService.publish(this.getErrorKey(eventKey), err)
        })
      });
  }

}
